/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const CareManagerSearchFragment = `
    fragment CareManagerSearchFragment on CareManagerUser {
  id
  careManagerId
  emrId
  username
  email
  firstName
  lastName
  email
  isEnabled
  isProvider
}
    `
export const CognitoSearchFragment = `
    fragment CognitoSearchFragment on Cognito {
  userStatus
  isEnabled
  userAttributes {
    sub
    given_name
    family_name
    email
    picture
    nickname
  }
}
    `
export const UserSearchFragment = `
    fragment UserSearchFragment on User {
  careManager {
    ...CareManagerSearchFragment
  }
  permitRoles
  cognito {
    ...CognitoSearchFragment
  }
}
    `
export const CareManagerFragment = `
    fragment CareManagerFragment on CareManagerUser {
  id
  careManagerId
  emrId
  username
  firstName
  lastName
  email
  pronouns
  isProvider
  isEnabled
  permissions {
    isSupervisor
    addPatients
    viewAllPatients
    isAdmin
    caseloadBulkSend
    accessToNotes
  }
}
    `
export const CognitoFragment = `
    fragment CognitoFragment on Cognito {
  userStatus
  isEnabled
  userAttributes {
    sub
    given_name
    family_name
    email
    picture
    pronouns
    nickname
    phone_number
  }
}
    `
export const UserFullFragment = `
    fragment UserFullFragment on User {
  careManager {
    ...CareManagerFragment
  }
  permitRoles
  cognito {
    ...CognitoFragment
  }
}
    `
export const UserProvisionedFullFragment = `
    fragment UserProvisionedFullFragment on ProvisionedUser {
  careManager {
    ...CareManagerFragment
  }
  permitRoles
  cognito {
    ...CognitoFragment
  }
}
    `
export const UsrNamesFragment = `
    fragment UsrNamesFragment on UserSummaryDisplayNames {
  expandedName
}
    `
export const UsrSummaryFragment = `
    fragment UsrSummaryFragment on UserSummary {
  careManagerId
  providerId
  cognitoUserId
  emrId
  identifiers {
    type
    value
  }
  display {
    ...UsrNamesFragment
  }
}
    `
export const UserSignUpWithGoogleDocument = `
    mutation userSignUpWithGoogle($content: GoogleSignUpInput!) {
  signUpGoogleUser(content: $content) {
    ...UserProvisionedFullFragment
  }
}
    ${UserProvisionedFullFragment}
${CareManagerFragment}
${CognitoFragment}`
export const UserSignUpDocument = `
    mutation userSignUp($content: UserSignUpInput!) {
  signUpUser(content: $content) {
    ...UserProvisionedFullFragment
  }
}
    ${UserProvisionedFullFragment}
${CareManagerFragment}
${CognitoFragment}`
export const UpdateUserDocument = `
    mutation updateUser($cognitoUserId: ID!, $content: UserUpdateInput!) {
  updateUser(cognitoUserId: $cognitoUserId, content: $content) {
    ...UserProvisionedFullFragment
  }
}
    ${UserProvisionedFullFragment}
${CareManagerFragment}
${CognitoFragment}`
export const RevokeUserDocument = `
    mutation revokeUser($id: String!) {
  revokeUser(_id: $id) {
    careManager {
      id
    }
    cognito {
      userStatus
    }
  }
}
    `
export const RemoveUserDocument = `
    mutation removeUser($id: String!) {
  removeUser(_id: $id) {
    careManager {
      id
    }
  }
}
    `
export const RestoreUserDocument = `
    mutation restoreUser($id: String!) {
  restoreUser(_id: $id) {
    careManager {
      id
    }
    cognito {
      userStatus
    }
  }
}
    `
export const ResendUserPasswordDocument = `
    mutation resendUserPassword($cognitoUserId: ID!) {
  resendUserPassword(cognitoUserId: $cognitoUserId) {
    isSuccess
  }
}
    `
export const GetAllUsersDocument = `
    query getAllUsers {
  getUsers {
    ...UserSearchFragment
  }
}
    ${UserSearchFragment}
${CareManagerSearchFragment}
${CognitoSearchFragment}`
export const GetUserDocument = `
    query getUser($email: String!) {
  getUser(email: $email) {
    ...UserFullFragment
  }
}
    ${UserFullFragment}
${CareManagerFragment}
${CognitoFragment}`
export const GetUserByCareManagerIdDocument = `
    query getUserByCareManagerId($id: ID!) {
  getUserById(content: {careManagerId: $id}) {
    ...UserFullFragment
  }
}
    ${UserFullFragment}
${CareManagerFragment}
${CognitoFragment}`
export const GetUserByCognitoUserIdDocument = `
    query getUserByCognitoUserId($id: ID!) {
  getUserById(content: {cognitoUserId: $id}) {
    ...UserFullFragment
  }
}
    ${UserFullFragment}
${CareManagerFragment}
${CognitoFragment}`
export const GetSecurityRolesDocument = `
    query getSecurityRoles {
  listSecurityRoles {
    name
    key
  }
}
    `
export const DescribeUsersByCareManagerIdDocument = `
    query describeUsersByCareManagerId($ids: [String!]!) {
  describeUsersByCareManagerId(careManagerIds: $ids) {
    ...UsrSummaryFragment
  }
}
    ${UsrSummaryFragment}
${UsrNamesFragment}`
export const DescribeUsersByProviderIdDocument = `
    query describeUsersByProviderId($ids: [String!]!) {
  describeUsersByProviderId(providerIds: $ids) {
    ...UsrSummaryFragment
  }
}
    ${UsrSummaryFragment}
${UsrNamesFragment}`
export const DescribeUsersByCognitoIdDocument = `
    query describeUsersByCognitoId($ids: [String!]!) {
  describeUsersByCognitoUserId(cognitoUserIds: $ids) {
    ...UsrSummaryFragment
  }
}
    ${UsrSummaryFragment}
${UsrNamesFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    userSignUpWithGoogle: build.mutation<
      Types.UserSignUpWithGoogle,
      Types.UserSignUpWithGoogleVariables
    >({
      query: (variables) => ({
        document: UserSignUpWithGoogleDocument,
        variables,
      }),
    }),
    userSignUp: build.mutation<Types.UserSignUp, Types.UserSignUpVariables>({
      query: (variables) => ({ document: UserSignUpDocument, variables }),
    }),
    updateUser: build.mutation<Types.UpdateUser, Types.UpdateUserVariables>({
      query: (variables) => ({ document: UpdateUserDocument, variables }),
    }),
    revokeUser: build.mutation<Types.RevokeUser, Types.RevokeUserVariables>({
      query: (variables) => ({ document: RevokeUserDocument, variables }),
    }),
    removeUser: build.mutation<Types.RemoveUser, Types.RemoveUserVariables>({
      query: (variables) => ({ document: RemoveUserDocument, variables }),
    }),
    restoreUser: build.mutation<Types.RestoreUser, Types.RestoreUserVariables>({
      query: (variables) => ({ document: RestoreUserDocument, variables }),
    }),
    resendUserPassword: build.mutation<
      Types.ResendUserPassword,
      Types.ResendUserPasswordVariables
    >({
      query: (variables) => ({
        document: ResendUserPasswordDocument,
        variables,
      }),
    }),
    getAllUsers: build.query<
      Types.GetAllUsers,
      Types.GetAllUsersVariables | void
    >({
      query: (variables) => ({ document: GetAllUsersDocument, variables }),
    }),
    getUser: build.query<Types.GetUser, Types.GetUserVariables>({
      query: (variables) => ({ document: GetUserDocument, variables }),
    }),
    getUserByCareManagerId: build.query<
      Types.GetUserByCareManagerId,
      Types.GetUserByCareManagerIdVariables
    >({
      query: (variables) => ({
        document: GetUserByCareManagerIdDocument,
        variables,
      }),
    }),
    getUserByCognitoUserId: build.query<
      Types.GetUserByCognitoUserId,
      Types.GetUserByCognitoUserIdVariables
    >({
      query: (variables) => ({
        document: GetUserByCognitoUserIdDocument,
        variables,
      }),
    }),
    getSecurityRoles: build.query<
      Types.GetSecurityRoles,
      Types.GetSecurityRolesVariables | void
    >({
      query: (variables) => ({ document: GetSecurityRolesDocument, variables }),
    }),
    describeUsersByCareManagerId: build.query<
      Types.DescribeUsersByCareManagerId,
      Types.DescribeUsersByCareManagerIdVariables
    >({
      query: (variables) => ({
        document: DescribeUsersByCareManagerIdDocument,
        variables,
      }),
    }),
    describeUsersByProviderId: build.query<
      Types.DescribeUsersByProviderId,
      Types.DescribeUsersByProviderIdVariables
    >({
      query: (variables) => ({
        document: DescribeUsersByProviderIdDocument,
        variables,
      }),
    }),
    describeUsersByCognitoId: build.query<
      Types.DescribeUsersByCognitoId,
      Types.DescribeUsersByCognitoIdVariables
    >({
      query: (variables) => ({
        document: DescribeUsersByCognitoIdDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
